module.exports = __webpack_public_path__ + "static/img/cont3610.2143c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3610.jpg
// module id = mHTT
// module chunks = 0